import * as d3 from 'd3';

export const parseDate = d3.timeParse('%Y-%m-%d');

export const momentFormat = 'YYYY-MM-DD';
